@if (loading()) {
  @if (loadingTemplate()) {
    <ng-container *ngTemplateOutlet="loadingTemplate()!"></ng-container>
  } @else {
    <cm-skeleton-loader [preset]="skeletonLoaderPreset()" />
  }
} @else if (error()) {
  @if (errorUseCardContainer()) {
    <cm-card>
      <ng-container *ngTemplateOutlet="errorContent"></ng-container>
    </cm-card>
  } @else {
    <ng-container *ngTemplateOutlet="errorContent"></ng-container>
  }
} @else if (empty()) {
  @if (emptyUseCardContainer()) {
    <cm-card>
      <ng-container *ngTemplateOutlet="emptyContent"></ng-container>
    </cm-card>
  } @else {
    <ng-container *ngTemplateOutlet="emptyContent"></ng-container>
  }
} @else {
  <ng-content />
}

<!-- Empty Content Template -->
<ng-template #emptyContent>
  <cm-section-empty
    [preset]="emptyPreset()"
    [icon]="emptyIcon()"
    [title]="emptyTitle()"
    [subtitle]="emptySubtitle()"
    [buttonLabel]="emptyButtonLabel()"
    [buttonIcon]="emptyButtonIcon()"
    [buttonLoading]="emptyButtonLoading()"
    (create)="onEmptyAction()"
  />
</ng-template>

<!-- Error Content Template -->
<ng-template #errorContent>
  <cm-section-empty
    [icon]="errorIcon()"
    [iconColor]="'danger'"
    [title]="errorTitle()"
    [subtitle]="errorSubtitle()"
    [buttonLabel]="errorButtonLabel()"
    (create)="onErrorRefreshAction()"
  />
</ng-template>